import type { SVGProps } from 'react'
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#whatsapp_svg__a)">
      <path d="m0 18 1.29-4.815A8.86 8.86 0 0 1 .176 8.89C.175 3.988 4.164 0 9.065 0c4.903 0 8.891 3.988 8.891 8.89s-3.988 8.89-8.89 8.89a8.9 8.9 0 0 1-4.226-1.076zm5.08-3.1.305.181a7.2 7.2 0 0 0 3.68 1.02c3.976 0 7.21-3.235 7.21-7.21s-3.234-7.21-7.21-7.21-7.21 3.234-7.21 7.21a7.2 7.2 0 0 0 1.055 3.738l.187.306-.72 2.689z" />
      <path
        clipRule="evenodd"
        d="M12.373 10.127c-.366-.22-.842-.464-1.273-.287-.331.135-.542.653-.756.917-.11.136-.242.157-.41.09-1.242-.495-2.193-1.324-2.878-2.466-.116-.178-.096-.317.044-.482.207-.243.467-.52.523-.849s-.098-.712-.234-1.004c-.173-.374-.367-.907-.742-1.118-.344-.194-.797-.086-1.103.164-.53.43-.785 1.106-.777 1.775q.003.287.07.563c.107.441.31.853.54 1.245q.26.445.564.858a8.7 8.7 0 0 0 2.447 2.272c.478.293.993.55 1.526.726.598.197 1.13.403 1.776.28.676-.128 1.342-.546 1.61-1.198.08-.193.12-.408.075-.611-.092-.421-.662-.672-1.002-.875"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="whatsapp_svg__a">
        <path d="M0 0h17.956v18H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgWhatsapp
